import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import toast, { Toaster } from "react-hot-toast";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Header } from "antd/lib/layout/layout";
import PreferencesNav from "./PreferencesNav";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddIcon from "@mui/icons-material/Add";

import {
  deliveryPersonList1,
  addDeliveryPerson,
  deliveryPersonUUID1,
  editDeliveryPerson1,
  activeInactiveDelivery,
} from "../../services/index";
import { searchForMatch } from "../utils/textUtils";

const DeliveryPersonList = () => {
  let navigate = useNavigate();

  const [success, setSuccess] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setName("");
    setPhone("");
    setEmail("");
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [edit, setEdit] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState([]);

  const [dataId, setDataId] = useState(false);

  const columns = [
    {
      name: "TITLE",
      cell: (row) => row.title,
    },
    {
      name: "PHONE ",
      selector: (row) => row.phone,
    },
    {
      name: "EMAIL ",
      selector: (row) => row.email,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* <EditIcon
            style={{ fontSize: "15px", cursor: "pointer" }}
            onClick={() => {
              navigate("/vendors/" + row.recordId + "/edit");
            }}
          />&nbsp;&nbsp; */}
          {row.active ? (
            <CheckCircleIcon
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: "greenyellow",
              }}
              onClick={() => handleActiveInactive(row)}
            />
          ) : (
            <CancelIcon
              style={{ fontSize: "15px", cursor: "pointer", color: "tomato" }}
              onClick={() => handleActiveInactive(row)}
            />
          )}
        </div>
      ),
    },
  ];

  const handleActiveInactive = (row) => {
    activeInactiveDelivery(row.recordId).then((res) => {
      if (res.errorCode == 0) {
        setSuccess(!success);
        toast(res.message);
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const handleSave = () => {
    if (name == "") {
      toast("Please fill name");
      return;
    }

    if (String(phone).length != 10 || phone == "") {
      toast("Please fill 10 digit phone ");
      return;
    }

    const data1 = {
      email: email,
      phone: phone,
      title: name,
    };

    edit
      ? editDeliveryPerson1(dataId, data1).then((res) => {
          if (res.errorCode == 0) {
            toast(res.message);
            refreshList();
            handleClose();
            setEmail("");
            setPhone("");
            setName("");
          } else {
            toast(res.message);
            return;
          }
        })
      : addDeliveryPerson(data1).then((res) => {
          if (res.errorCode == 0) {
            toast(res.message);
            refreshList();
            handleClose();

            setEmail("");
            setPhone("");
            setName("");
          } else {
            toast(res.message, { autoClose: 2000 });
            return;
          }
        });
  };

  const handleClicked = (id) => {
    deliveryPersonUUID1(id).then((res) => {
      if (res.errorCode == 0) {
        var temp = res.responsePacket.data;
        setName(res.responsePacket.title);
        setPhone(res.responsePacket.phone);
        setEmail(res.responsePacket.email);
      } else {
        toast(res.message, { autoClose: 2000 });
        return;
      }
    });

    handleShow();
    setEdit(true);
  };

  const refreshList = () => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };

    deliveryPersonList1(data).then((res) => {
      if (res.errorCode == 0) {
        var temp = res.responsePacket.data;
        setRows(temp);
        setFilteredData(temp);
      } else {
        toast(res.message);
      }
    });
  };

  useEffect(() => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };

    deliveryPersonList1(data).then((res) => {
      if (res.errorCode == 0) {
        var temp = res.responsePacket.data;
        setRows(temp);
        setFilteredData(temp);
      } else {
        toast(res.message);
      }
    });
  }, [success]);

  useEffect(() => {
    const result = rows.filter((data) => {
      return searchForMatch(data.title, search);
    });
    setFilteredData(result);
  }, [search]);

  const handleNew = () => {
    setEdit(false);
    handleShow();
    setEmail("");
    setPhone("");
    setName("");
  };

  return (
    <>
      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            Delivery Person List
          </span>
        </div>

        <div className="list-filter">
          <Modal show={show} onHide={handleClose}>
            <Modal.Body>
              <Header>Delivery Person Info</Header>
              <br />
              <hr />

              <table>
                <tr>
                  <td>Name:</td>
                  <td>
                    {" "}
                    <input
                      autoComplete="off"
                      className="ember-text-field ember-view form-control"
                      type="text"
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      value={name}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Phone:</td>
                  <td className="otp-spin">
                    <input
                      autoComplete="off"
                      className="ember-text-field ember-view form-control"
                      type="number"
                      onChange={(e) => {
                        let limitedValue = e.target.value.slice(0, 10);
                        setPhone(limitedValue);
                      }}
                      value={phone}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Email:</td>
                  <td>
                    <input
                      autoComplete="off"
                      className="ember-text-field ember-view form-control"
                      type="text"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                    />
                  </td>
                </tr>
              </table>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary" onClick={handleSave}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            fixedHeader
            pointerOnHover={true}
            highlightOnHover={true}
            onRowClicked={(data) => {
              setDataId(data.recordId);
              handleClicked(data.recordId);
            }}
            subHeader
            subHeaderComponent={
              <div className="d-flex align-items-center">
                <div className="input-group mr-2 paginationSearchInput">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <SearchRoundedIcon />
                    </span>
                  </div>
                  <input
                    autoComplete="off"
                    className="form-control"
                    type="text"
                    placeholder={"Search here"}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={handleShow}
                >
                  <AddIcon />
                  New
                </button>
              </div>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default DeliveryPersonList;
